import { useTranslation } from "react-i18next";
import { services } from "@/mocks/siteData";
import SectionHeading from "@/components/feature/SectionHeading";

export default function ServicesSection() {
  const { t } = useTranslation();

  return (
    <section id="services" className="py-20 md:py-28 bg-background-100">
      <div className="max-w-7xl mx-auto px-4 md:px-8">
        <SectionHeading
          eyebrow={t("services.eyebrow")}
          title={
            <>
              {t("services.title1")}
              <br />
              {t("services.title2")}
            </>
          }
          subtitle={t("services.subtitle")}
        />

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-5 md:gap-6">
          {services.map((service) => {
            const title = t(`services.${service.id}.title`);
            return (
              <div
                key={service.id}
                className="group bg-background-50 border border-background-200 hover:border-primary-300 rounded-lg p-7 md:p-8 transition"
              >
                <div className="w-14 h-14 rounded-lg bg-primary-100 text-primary-700 flex items-center justify-center group-hover:bg-primary-500 group-hover:text-background-50 transition">
                  <i className={`${service.icon} text-2xl w-7 h-7 flex items-center justify-center`} />
                </div>
                <h3 className="mt-6 font-heading text-xl font-bold text-foreground-900">{title}</h3>
                <p className="mt-3 text-foreground-500 text-[15px] leading-relaxed">
                  {t(`services.${service.id}.description`)}
                </p>
                <a
                  href="#contact"
                  className="mt-6 inline-flex items-center gap-2 text-primary-700 hover:text-primary-800 font-semibold text-sm cursor-pointer transition"
                >
                  {t("services.learnMore")}
                  <i className="ri-arrow-right-line w-4 h-4 flex items-center justify-center group-hover:translate-x-1 transition" />
                </a>
              </div>
            );
          })}
        </div>
      </div>
    </section>
  );
}